import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import {
  ENTER_MOBILE_NUMBER,
  ENTER_OTP,
  INVALID_MOBILE_NUMBER,
  REQUEST_NEW_OTP,
  REQUEST_OTP,
  LOGIN,
  SOMETHING_WENT_WRONG,
  USER_DOES_NOT_EXIST,
  INVALID_OTP,
} from "../../constants/string";
import axios from "../../network";
import * as Sentry from "@sentry/react";
import { SIGNUP } from "../../constants/paths";

const OtpLogin = ({phoneNo, dialCode}) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState(dialCode ? dialCode : "");
  const [fullMobileNumber, setFullMobileNumber] = useState(phoneNo ? phoneNo : "");
  const [otp, setOtp] = useState("");
  const [isOtpRequested, setIsOtpRequested] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const navigate = useNavigate();
  const { login } = useAuth();
  const [userName, setUserName] = useState("");
  const [requestToken, setRequestToken] = useState("");

  useEffect(() => {
    let interval;
    if (otpTimer > 0 && isOtpRequested) {
      interval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [otpTimer, isOtpRequested]);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data && data.phoneNumber) {  
          handleMobileNumberChange(data.phoneNumber, data.dialCode);
        }
      } catch (error) {
        console.error("Invalid JSON data received:", event.data);
      }
    };
  
    window.addEventListener('message', handleMessage);
  
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const isValidMobileNumber = (number) => {
    return /^\+?[6-9]\d{9}$/.test(number);
  };
  useEffect(() => {
    if (phoneNo && dialCode) {
      const initialCountryCode = `+${dialCode}`;
      const initialMobileNumber = phoneNo.startsWith(dialCode)
        ? phoneNo.slice(dialCode.length)
        : phoneNo;
  
      setCountryCode(initialCountryCode);
      setMobileNumber(initialMobileNumber);
      setFullMobileNumber(`${initialCountryCode}${initialMobileNumber}`);
    }
  }, [phoneNo, dialCode]);

  const handleMobileNumberChange = (value, country) => {
    setFullMobileNumber(value);
    setCountryCode(`+${country?.dialCode || country }`); 
    setMobileNumber(value.replace(`${country?.dialCode || country}`, ""));
  };

  const handleOtpChange = (event) => {
    setOtp(event.target.value);
  };

  const handleOtpRequest = () => {
    if (isValidMobileNumber(mobileNumber)) {
      const contactDetails = {
        mobileNumber: mobileNumber,
        dialcode: countryCode,
      };
      axios
        .post("users/bikriLogin", contactDetails)
        .then((res) => {
          if (res.data.Result === "true") {
            setIsOtpRequested(true);
            setOtpTimer(30);
            setUserName(res.data.data.username);
            setRequestToken(res.data.data.requesttoken);
          } else {
              axios
                .get(`NewUserDetails/userSignUpStatus?number=${mobileNumber}`)
                .then((signUpRes) => {
                  const userSignUpStatus = (signUpRes.data.Result === true ? "completed" : "pending");
                  if(userSignUpStatus === "pending") {
                    const userChoice = window.confirm(USER_DOES_NOT_EXIST);
                    if (!userChoice) {
                      return;
                    }
                  }
                    navigate(SIGNUP, {state: { contactDetails, userSignUpStatus },});
                })
                .catch((err) => {
                  alert("Error fetching sign-up status");
                });
            
          }
        })
        .catch((err) => alert(SOMETHING_WENT_WRONG));
    } else {
      alert(INVALID_MOBILE_NUMBER);
    }
  };

  const handleOtpLogin = () => {
    Sentry.setUser({
      id: mobileNumber,
      mobileNumber: mobileNumber,
      userName: userName,
    });
    const requestpayload = {
      requesttoken: requestToken,
      otp: otp,
      username: userName,
      medium: 3,
    };

    axios
      .post(
        "users/validateTheOtp",
        { User: requestpayload },
        { params: { accessTokenRequired: 1 } }
      )
      .then((res) => {
        if (res.data.Result) {
          login(res.data.accessToken);
          navigate("/");
        } else {
          alert(INVALID_OTP);
        }
      })
      .catch(() => {
        alert(SOMETHING_WENT_WRONG);
      });
  };

  return (
    <Box
      component="form"
      noValidate
      sx={{
        mt: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <PhoneInput
        country="in"
        placeholder={ENTER_MOBILE_NUMBER}
        value={fullMobileNumber}
        onChange={handleMobileNumberChange}
        disabled={isOtpRequested}
        inputStyle={{ width: '100%' }}
        containerStyle={{ width: '120%' }}
        specialLabel=""
      />
      {!isOtpRequested && (
        <Button
          onClick={handleOtpRequest}
          variant="contained"
          color="primary"
          sx={{ width: "120%", mt: 2, padding: 1.4 }}
        >
          {REQUEST_OTP}
        </Button>
      )}
      {isOtpRequested && (
        <>
          <TextField
            type="number"
            id="otp"
            placeholder={ENTER_OTP}
            value={otp}
            onChange={handleOtpChange}
            sx={{ width: "120%", mt: 2 }}
          />
          <Button
            onClick={handleOtpLogin}
            variant="contained"
            color="primary"
            sx={{ width: "120%", mt: 2, padding: 1.4 }}
          >
            {LOGIN}
          </Button>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ width: "100%", mt: 2 }}
          >
            {otpTimer > 0 ? (
              `Request new OTP in ${otpTimer} seconds`
            ) : (
              <Button onClick={handleOtpRequest} sx={{ width: "100%" }}>
                {REQUEST_NEW_OTP}
              </Button>
            )}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default OtpLogin;
